const bundleForm = document.querySelector('.product-form');
const inputRows = bundleForm.querySelectorAll('.input-row variant-picker');

inputRows.forEach((row) => {
  const optLabel = row.querySelector('.opt-label:first-of-type');
  optLabel.click()
  const optBtn = row.querySelector('.opt-btn:first-of-type');
  optBtn.setAttribute('checked', 'checked');
  onChange = new Event('change');
  // console.log(row);
  setTimeout(() => {
    row.dispatchEvent(onChange);
  })
})

inputRows.forEach((row) => {
  
  var hidefit = row.querySelectorAll('.hide-fit__sizes');
  if(hidefit && hidefit.length > 0) {
  var fitwrapper = row.querySelectorAll('[data-option="Select Fit"]');
  fitwrapper.forEach((fit_wrap) => {
      var fit_input = fit_wrap.querySelectorAll('custom-select li');
  
      if(fit_input && fit_input.length > 0) {
          fit_input.forEach((fit) => {
          fit.addEventListener('click', () => {
            setTimeout(() => {
              var wrapper = row.querySelectorAll('[data-option="Size"]');
              wrapper.forEach((wrap)=> {
                  var customSelect = wrap.querySelector('custom-select');
                  var buttonSelect = wrap.querySelector('.custom-select__btn');
                  var inputElements = wrap.querySelectorAll('custom-select li');
                  var is_fitChecked = wrap.querySelector('custom-select li[aria-selected="true"]')
                
                  if(is_fitChecked.classList.contains('is-nonexistent')) {
                    for (const input of inputElements) {
                      input.setAttribute('aria-selected', 'false');
                    }
                    for (const input of inputElements) {
                      if (!input.classList.contains('is-nonexistent')) {
                      input.setAttribute('aria-selected', 'true');
                        
                        const detail = { selectedValue: input.dataset.value };
                        customSelect.dispatchEvent(new CustomEvent('change', { bubbles: true, detail }));
                        
                        buttonSelect.firstElementChild.textContent = input.dataset.value;
                        
                        break;
                      }
                    }
                  }
              })
            }, 300)
            
          })
        })
      } else {
        var input_btn = fit_wrap.querySelectorAll('input');
        input_btn.forEach((fit) => {
          fit.addEventListener('click', () => {
            setTimeout(() => {
              var wrap = row.querySelector('[data-option="Size"]');
              var inputElements = wrap.querySelectorAll('input');
              var is_fitChecked = wrap.querySelector('input[type="radio"]:checked')
              if (is_fitChecked) {
                is_fitChecked.checked = false;
                
                // const addToCartBtn = document.querySelector('.buy-buttons-row .add-to-cart');
                // addToCartBtn.dataset.addToCartText = 'Select a size';
                // addToCartBtn.textContent = 'Select a size';
                // addToCartBtn.removeAttribute('disabled');
                
                // const stickyAddToCartBtn = document.querySelector('.sticky-atc__buttons .add-to-cart');
                // stickyAddToCartBtn.dataset.addToCartText = 'Select a size';
                // stickyAddToCartBtn.textContent = 'Select a size';
              }
              if(is_fitChecked.classList.contains('is-nonexistent')) {
                for (const input of inputElements) {
                  if (!input.classList.contains('is-nonexistent')) {
                    var input_id = input.getAttribute('id')
                    var label = wrap.querySelector(`label[for=${input_id}]`)
                    label.click();
                    break;
                  }
                }
              }
              // const errorNotif = document.querySelector('#no-size-selected');
              // errorNotif.classList.remove('show')
            }, 300)
            
          })
        })
      }
        
    })
  }
})

